import { useState, useEffect } from "react";
import "./MonitoringBenefit.css";
import img1 from "../monitoringassets/benefit1.png";
import img2 from "../monitoringassets/benefit2.png";
import img3 from "../monitoringassets/benefit3.png";
import img4 from "../monitoringassets/benefit4.png";
import img5 from "../monitoringassets/benefit5.png";
import img6 from "../monitoringassets/benefit6.png";

export default function MonitoringBenefit() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [slidesToShow, setSlidesToShow] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 992);

      if (width < 576) {
        setSlidesToShow(1);
      } else if (width < 992) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(1);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const contentItems = [
    {
      img: img1,
      title: "Unmatched Experience",
      description:
        "Our experienced AI experts understand diverse industry needs and help unlock the transformative potential of Generative AI for your business.",
    },
    {
      img: img2,
      title: "Focus on Security", 
      description:
        "With a strong focus on data security and compliance, we protect your critical business information from breaches and unauthorized access.",
    },
    {
      img: img3,
      title: "Rapid Development",
      description:
        "Get from ideation to implementation quickly in weeks using our rapid AI development frameworks and accelerators.",
    },
    {
      img: img4,
      title: "Top 1% Talent",
      description:
        "Proficient in machine learning, deep learning, and natural language processing, our leaders deliver high-performing solutions tailored to diverse business needs.",
    },
    {
      img: img5,
      title: "Tailored Solutions",
      description:
        "We work closely with you to understand your unique challenges and build custom Generative AI models tailored to your specific use cases and goals.",
    },
    {
      img: img6,
      title: "Dedicated Support",
      description:
        "We provide continuous support and maintenance to ensure your Generative AI solutions stay secure, high-performing, and aligned with the latest technology.",
    },
  ];

  const totalSlides = Math.ceil(contentItems.length / slidesToShow);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  const getVisibleItems = () => {
    const items = [];
    for (let i = 0; i < totalSlides; i++) {
      const start = i * slidesToShow;
      const end = Math.min(start + slidesToShow, contentItems.length);
      items.push(contentItems.slice(start, end));
    }
    return items;
  };

  return (
    <div id="monitor-benefit" className="outsourcemainclass">
      <div className="bottom">
        <div className="card left-card">
          <h2 className="heading">
            Why BastionEx is Your Trusted Generative AI Development Partner
          </h2>
          <p className="subheading">
            Leverage the power of a trusted technology partner to accelerate
            your business growth.
          </p>
        </div>

        {isMobile ? (
          <div className="carousel-container">
            <div className="carousel-wrapper">
              <div
                className="carousel-slides"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {getVisibleItems().map((slideItems, slideIndex) => (
                  <div className="carousel-slide" key={slideIndex}>
                    <div
                      className={`carousel-slide-content slides-${slidesToShow}`}
                    >
                      {slideItems.map((item, itemIndex) => (
                        <div className="content" key={itemIndex}>
                          <img src={item.img} alt="error" />
                          <h2>{item.title}</h2>
                          <span>{item.description}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="carousel-controls">
              <button className="carousel-btn prev" onClick={prevSlide}>
                ‹
              </button>
              <div className="carousel-dots">
                {Array.from({ length: totalSlides }).map((_, index) => (
                  <span
                    key={index}
                    className={`dot ${currentSlide === index ? "active" : ""}`}
                    onClick={() => setCurrentSlide(index)}
                  ></span>
                ))}
              </div>
              <button className="carousel-btn next" onClick={nextSlide}>
                ›
              </button>
            </div>
          </div>
        ) : (
          <div className="grid-container">
            {contentItems.map((item, index) => (
              <div className="content" key={index}>
                <img src={item.img} alt="error" />
                <h2>{item.title}</h2>
                <span>{item.description}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
